<template>
  <div class="recent_operations">
    <h3 class="component_heading">
      {{ $t("tickets_and_bar.operations.heading") }}
      <div class="hint right">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
              d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm1 11v2h-2v-2h2zm-1-8c.897 0 1.705.363 2.229.938.523.574.771 1.319.771 2.062 0 1.286-.73 2.18-1.244 2.773-.515.594-.756.892-.756 1.227h-2c0-1.202.759-1.978 1.244-2.537.485-.56.756-.898.756-1.463 0-.296-.1-.551-.25-.717C12.6 9.118 12.406 9 12 9c-.396 0-.588.12-.744.293-.156.174-.256.44-.256.707H9c0-.732.25-1.467.768-2.043C10.286 7.381 11.093 7 12 7z"
              fill="#FFF"
              fill-rule="nonzero"
            />
          </g>
        </svg>
        <div class="hint_expl">{{ $t("tickets_and_bar.operations.oper_expl") }}</div>
      </div>
    </h3>
    <div class="operations">
      <div class="item heading">
        <div class="table_data">
          <div class="oper_dt">{{ $t("tickets_and_bar.operations.oper_dt") }}</div>
          <div class="mvi">{{ $t("tickets_and_bar.operations.mvi") }}</div>
          <div class="sess_dt">{{ $t("tickets_and_bar.operations.sess_dt") }}</div>
          <div class="tickets">{{ $t("tickets_and_bar.operations.tickets") }}</div>
          <div class="bar">Бар</div>
          <div class="cost">{{ $t("tickets_and_bar.operations.cost") }}</div>
          <div class="dets">{{ $t("tickets_and_bar.operations.dets") }}</div>
        </div>
      </div>
      <div
        class="item"
        v-for="(order, orderNum) in historyOrders"
        :key="orderNum"
        :class="{ 'refunded': order.payment_status !== 10, 'open': order.dets_visible }"
      >
        <div class="mobile_data">
          <p class="mob_heading">
            {{ historyFilms[order.film][$i18n.locale].title }}
            <span
              v-if="order.payment_status !== 10"
              class="refunded"
            >({{ $t("tickets_and_bar.operations.tickets_refunded") }})</span>
          </p>
          <p class="mob_date">Сеанс на {{ order.dateStr }}, {{ order.timeStr }}</p>
          <div class="dets mob_dets" @click.stop="order.dets_visible = !order.dets_visible">
            <div class="det_pic"></div>
          </div>
        </div>
        <div
          class="table_data"
          v-show="winW >= 1024 || order.dets_visible"
          @click="order.dets_visible = !order.dets_visible"
        >
          <div class="oper_dt">
            <p class="mob_key">{{ $t("tickets_and_bar.operations.oper_dt") }}:</p>
            <p class="val">{{ order.operDateStr }}, {{ order.operTimeStr }}</p>
          </div>
          <div class="mvi">
            <p class="mob_key">{{ $t("tickets_and_bar.operations.mvi") }}:</p>
            <p class="val">
              {{ historyFilms[order.film][$i18n.locale].title }}
              <span
                v-if="order.payment_status !== 10"
                class="refunded"
              >({{ $t("tickets_and_bar.operations.tickets_refunded") }})</span>
            </p>
          </div>
          <div class="sess_dt">
            <p class="mob_key">{{ $t("tickets_and_bar.operations.sess_dt") }}:</p>
            <p class="val">{{ order.dateStr }}, {{ order.timeStr }}</p>
          </div>
          <div class="tickets">
            <p class="mob_key">{{ $t("tickets_and_bar.operations.tickets") }}:</p>
            <p class="val">{{ order.tickets.length }}</p>
          </div>
          <div class="bar">
            <p class="mob_key">Бар:</p>
            <p class="val">{{ order.bar.length }}</p>
          </div>
          <div class="cost">
            <p class="mob_key">{{ $t("tickets_and_bar.operations.cost") }}:</p>
            <p class="val">{{ order.amount / 100 }} грн</p>
          </div>
          <div class="dets" style="cursor: pointer; text-align: right">
            <div class="det_pic"></div>
          </div>
        </div>
        <div class="additional_info" v-show="order.dets_visible">
          <p class="ta_num">
            <span class="ta_num_key">{{ $t("tickets_and_bar.operations.num_order") }}:</span>
            <span class="ta_num_val">{{ order.booking_number }}</span>
          </p>
          <div class="half">
            <p class="heading">{{ $t("tickets_and_bar.operations.tickets") }}:</p>
            <div class="ta_nums">
              <p
                v-for="(ticket, ticketNum) in order.tickets"
                :key="ticketNum"
              >{{ $t("tickets_and_bar.operations.row") }} {{ ticket.row }}, {{ $t("tickets_and_bar.operations.seat") }} {{ ticket.seat }}</p>
            </div>
          </div>
          <div class="half" v-if="order.bar.length > 0">
            <p class="heading">{{ $t("tickets_and_bar.operations.bar_goods") }}:</p>
            <div class="ta_nums">
              <p v-for="(bar, barNum) in order.bar" :key="barNum">
                <span>{{ bar.qty }} шт.</span>
                {{ historyItems[bar.item].name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      class="moreOperations"
      @click.prevent="getHistoryOrders"
      v-if="!noMoreOperations"
    >{{ $t("tickets_and_bar.operations.more") }}</span>
    <p class="nomore" v-if="noMoreOperations">{{ $t("tickets_and_bar.operations.no_more") }}</p>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    winW: function () {
      return Store.state.winW
    },
    historyOrders: function () {
      return Store.state.historyOrders
    },
    historyFilms: function () {
      return Store.state.historyFilms
    },
    historyItems: function () {
      return Store.state.historyItems
    },
    noMoreOperations: function () {
      return Store.state.noMoreOperations
    }
  },
  methods: {
    getHistoryOrders: function () {
      Store.dispatch('getHistoryOrders', false)
    }
  },
  destroyed: () => {
    Store.commit('emptyHistoryOrders')
  }
}
</script>


// WEBPACK FOOTER //
// operations.vue?69fe8e3e